<form [formGroup]="form">
  <mat-form-field
    [color]="color"
    class="mojo-numeric-input w-100"
  >
    <mat-label>{{label}}</mat-label>
    <input
      class="custom-numeric-input"
      matInput
      formControlName="input"
      type="number"
      data-cy="mojo-numeric-input"
    />
    <div
      class="arrows-wrapper"
      matSuffix
    >
      <button
        (click)="upClicked()"
        data-cy="mojo-numeric-input-up-button"
      >
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <button
        (click)="downClicked()"
        [disabled]="control?.value === min"
        data-cy="mojo-numeric-input-down-button"
      >
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </div>
  </mat-form-field>
</form>
